// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/_foundation.js";
import "jquery.scrollbar";
import "jquery-match-height";
// import initPreloader from "./modules/preloaderPace";
// import homePageAnimations from "./modules/homePageAnimations";
import journeyPageAnimations from "./modules/journeyPageAnimations";
import slidePopup from "./modules/slidePopup";
import staffPopup from "./modules/staff-popup";
import commentFormValidation from "./modules/commentFormValidation";
import pageScrollAnim from "./modules/page-scroll-anim";
import navBtnAnimScroll from "./modules/navBtnAnimationScroll";
import ScrollMagic from "scrollmagic";
import "./modules/filter-terms";
import "./modules/filter-posts-term";
import "./modules/load-all-posts";
import "./modules/related-slider";
import "./modules/jquery.rwdImageMaps.min";


// Import Slick
import "slick-carousel";
import homePageAnimations from "./modules/homePageAnimations";

jQuery(document).ready(() => {

	$("img[usemap]").rwdImageMaps();

	//Smooth Scroll Anchor
	$('a[href="#sub-hero-section"]').click(function (e) {
		e.preventDefault();
		$("html, body").animate(
			{
				scrollTop: $('[id="' + $.attr(this, "href").substr(1) + '"]').offset()
					.top,
			},
			1000
		);
		return false;
	});

	if ($('.journey-menu li').length >= 1) {
		$('.journey-menu li:first-child a').append('<span class="arrow-right"></span>');
	}

	// Toggle Menu
	const toggleItem = $(".toggle-menu-main"),
		openMenu = $(".header__menu");
	let scrollPos = 0;
	toggleItem.on("click", function () {
		if (!toggleItem.hasClass("open")) {
			toggleItem.addClass("open");
			openMenu.addClass("active");
			scrollPos =
				pageYOffset ||
				(document.documentElement.clientHeight
					? document.documentElement.scrollTop
					: document.body.scrollTop);
			$("body").css({
				overflow: "hidden",
				width: "100%",
				// position: "fixed",
				top: -scrollPos,
			});
		} else {
			toggleItem.removeClass("open");
			openMenu.removeClass("active");
			$("body").css({
				overflow: "",
				width: "",
				// position: "",
				top: "",
			});
			if (scrollPos !== 0) {
				$(window).scrollTop(scrollPos);
			}
		}
	});

	$(document).keyup(function (e) {
		if (e.keyCode === 27) {
			toggleItem.removeClass("open");
			openMenu.removeClass("active");
		}
	});

	// Init scripts for home page only
	if (themeVars.journeyTemplate) {
		journeyPageAnimations();
	}
	if (themeVars.isHome) {
		homePageAnimations();
	}
	slidePopup();

	//add popup on staff page
	staffPopup();

	//add form validation on comment form
	if ($("body").hasClass("single-post")) {
		commentFormValidation();
	}

	// nice scroll
	$("div.nice-scroll").scrollbar();
	$("#primary-menu").scrollbar();

	//add nav button animation that change color on scroll
	if ($(document).find(".white-trigger-js") && themeVars.isHome) {
		navBtnAnimScroll();
	}

	//trigger hover on img when hovering title on blog page
	if ($("body").is(".blog")) {
		$(".entry-title").each(function () {
			$(this).hover(function () {
				$(this)
					.parent()
					.parent()
					.find(".entry-img")
					.toggleClass("hovered-title");
			});
		});
	}
	//match height for collaborators page
	$(".staff-elem a").matchHeight();
});

$(window).load(function () {

	if ($('.triggers-humb').length >= 1) {
		let heightTriggerElm = $('.triggers-humb').outerHeight(true) + 2000;
		//Trigers Color Humburger
		const controller = new ScrollMagic.Controller();
		// build scene and set duration to window height
		const scene = new ScrollMagic.Scene({
			triggerElement: ".triggers-humb",
			duration: heightTriggerElm+'px',
			offset: 0,
			triggerHook: 0.1,
		})
			.setClassToggle(".toggle-menu-main", "dark-color")
			.addTo(controller);

		console.log(scene);
	}

	$('body').addClass('start-animation');
	$(
		".wide-page, .map-page, .hero, .blog-page-header, .page-content-js, .mob-home-section__hero"
	).addClass("anim-loaded");

	//add anim for all page accept front page
	if ($(".header").is(".not-front-page")) {
		$(".header").addClass("anim-loaded");
	}

	//randomise hero anim
	if ($(".hero").is(".anim-loaded")) {
		$(".hero__bg").css(
			"transform-origin",
			Math.floor(Math.random() * 100) +
			"% " +
			Math.floor(Math.random() * 100) +
			"%"
		);
	}

	//add scroll anim on blog page
	if (
		$("body").is(
			".blog, .single-post, .page-template-bios, .page-template-statue-advocacy"
		)
	) {
		pageScrollAnim();
	}

	if ($("body").is(".page-template-page-simple, .page-template-bios")) {
		$(".page-content__text > *").each(function () {
			$(this).attr("data-aos", "fade-up");
		});

		pageScrollAnim();
	}

	//add scroll anim om home when mobile
	if (screen.width < 767 && themeVars.isHome || screen.width < 767 && themeVars.journeyTemplate) {
		pageScrollAnim();
	}
});



// WEBPACK FOOTER //
// ./scripts/main.js